"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SDKFunc;

require("core-js/modules/es6.regexp.match");

// 调用原生方法
function SDKFunc(apiName, msg) {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端

  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
  // 如果是安卓

  if (isAndroid) {
    if (apiName === 'nativeShare') {
      try {
        window.Android.nativeShare(JSON.stringify(msg));
      } catch (error) {
        console.log(error);
      }
    }
  } // 如果是ios


  if (isiOS) {
    if (apiName === 'nativeShare') {
      try {
        window.nativeShare(msg);
      } catch (error) {
        console.log(error);
      }

      try {
        window.webkit.messageHandlers.nativeShare.postMessage(msg);
      } catch (error) {
        console.log(error);
      }
    }
  }
}